import FormService from "@/services/FormService";

/**
 * File Download Mixin
 *
 * Provides shared functionality for downloading form attachment files.
 * Can be used by components that need to download files from form attachments.
 *
 * Usage:
 * import fileDownloadMixin from "@/mixins/forms/fileDownloadMixin";
 *
 * export default {
 *   mixins: [fileDownloadMixin],
 *   // ... rest of component
 * }
 *
 * Methods provided:
 * - downloadFile(attachment) - Downloads a single file from an attachment object
 * - downloadFileById(formAttachmentId) - Downloads a file by ID directly
 *
 * Data provided:
 * - downloadErrorText - Error message for failed downloads
 */
export default {
  data() {
    return {
      downloadErrorText: "Download is not currently available. Please try again later",
    };
  },
  methods: {
    /**
     * Downloads a file from an attachment object
     * @param {Object} attachment - The attachment object containing formAttachmentId
     */
    async downloadFile(attachment) {
      if (!attachment || !attachment.formAttachmentId) {
        console.error("Invalid attachment object provided to downloadFile");
        return;
      }

      return this.downloadFileById(attachment.formAttachmentId);
    },

    /**
     * Downloads a file by form attachment ID
     * @param {string|number} formAttachmentId - The ID of the form attachment
     */
    async downloadFileById(formAttachmentId) {
      try {
        console.log("downloading file", formAttachmentId);
        const {
          result: { url },
        } = await FormService.getFormAttachmentFile(formAttachmentId);

        if (url) {
          window.open(url, "_blank");
        } else {
          throw new Error("No URL found for file");
        }
      } catch (error) {
        console.error("Error downloading file:", error);
        this.$store.dispatch("showSnackbar", {
          text: this.downloadErrorText,
          color: "error",
        });
      }
    },
  },
};
